import { Text, Tooltip } from '@mantine/core';
import type { ReactNode } from 'react';

interface Props {
  label: ReactNode;
  /** Текст всплывающей подсказки при наведении на название поля. */
  hint: ReactNode;
}

/**
 * Лейбл поля со всплывающей подсказкой при наведении — замена `description`
 * под полем. Описание под одним полем в строке `Group grow` увеличивает его
 * высоту и ломает выравнивание соседних полей; подсказка на лейбле этого не
 * делает. Название подчёркнуто пунктиром и имеет курсор-подсказку.
 *
 * ```
 * <TextInput label={<LabelWithHint label="Вес упаковки, кг" hint="Авто: брутто − нетто" />} />
 * ```
 */
export function LabelWithHint({ label, hint }: Props) {
  return (
    <Tooltip label={hint} withArrow multiline w={260} position="top-start">
      <Text
        size="sm"
        fw={500}
        component="span"
        style={{ borderBottom: '1px dotted var(--mantine-color-dimmed)', cursor: 'help' }}
      >
        {label}
      </Text>
    </Tooltip>
  );
}
